import { render, staticRenderFns } from "./ContractChatConfirm.vue?vue&type=template&id=79c47286&scoped=true&lang=pug"
import script from "./ContractChatConfirm.vue?vue&type=script&lang=js"
export * from "./ContractChatConfirm.vue?vue&type=script&lang=js"
import style0 from "./ContractChatConfirm.vue?vue&type=style&index=0&id=79c47286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c47286",
  null
  
)

export default component.exports